import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap";
// toast
import { toast } from "react-toastify";
// service
import { getSalesProducts } from "../../../../utils/services/sales";
// utils
import { formatAmount } from "./formatters";

// Produtos (itens) de uma venda: descrição, grupos associados, quantidade, unitário de
// tabela e subtotal, com desconto do cupom e total pago no rodapé.
export default function ModalProducts(props) {
  const { isOpen, toggle, idSelected, token } = props;
  // carregar
  const [loading, setLoading] = useState(true);
  // dados
  const [products, setProducts] = useState([]);
  const [summary, setSummary] = useState(null);

  // busca os itens e o resumo da venda
  function getInfo() {
    getSalesProducts({ jwt: token, idSale: idSelected })
      .then((res) => {
        setProducts(Array.isArray(res?.products) ? res.products : []);
        setSummary(res?.summary || null);
      })
      .catch(() => toast.error("Não foi possível carregar os produtos"))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    getInfo();
  }, []);

  const promoOff = Number(summary?.promo_off) || 0;

  return (
    <Modal isOpen={isOpen} centered size="lg" scrollable>
      <ModalHeader toggle={toggle}>Produtos</ModalHeader>
      <ModalBody>
        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <div className="circle-loading" />
          </div>
        ) : (
          <div className="table-responsive border rounded-3 consolidated-sales-cards">
            <Table
              striped
              hover
              className="table mb-0 align-middle consolidated-sales-table"
            >
              <thead className="table-light align-top text-nowrap">
                <tr>
                  <th>Produto</th>
                  <th className="text-end">Quantidade</th>
                  <th className="text-end">Valor unitário</th>
                  <th className="text-end">Subtotal</th>
                </tr>
              </thead>
              <tbody>
                {products.length === 0 && (
                  <tr>
                    <td colSpan={4} className="text-center text-muted py-4">
                      Sem produtos
                    </td>
                  </tr>
                )}
                {products.map((p) => (
                  <tr key={p.item_id}>
                    <td data-label="Produto">
                      <div className="fw-semibold">{p.description}</div>
                      {p.description2 && (
                        <div className="text-muted font-size-12">{p.description2}</div>
                      )}
                      {Array.isArray(p.groups) && p.groups.length > 0 && (
                        <div className="d-flex flex-wrap gap-1 mt-1" aria-label="Grupos">
                          {p.groups.map((group) => (
                            <span
                              key={group}
                              className="badge rounded-pill badge-soft-info font-size-11"
                            >
                              {group}
                            </span>
                          ))}
                        </div>
                      )}
                    </td>
                    <td data-label="Quantidade" className="text-end text-nowrap">
                      {p.quantity}
                    </td>
                    <td data-label="Valor unitário" className="text-end text-nowrap">
                      {formatAmount(p.unit_price)}
                    </td>
                    <td data-label="Subtotal" className="text-end text-nowrap">
                      {formatAmount(p.subtotal)}
                    </td>
                  </tr>
                ))}
              </tbody>
              {summary && products.length > 0 && (
                <tfoot className="table-light">
                  {promoOff > 0 && (
                    <tr>
                      <td colSpan={3} data-label="" className="text-end text-muted">
                        Desconto{summary.promo_code ? ` (cupom ${summary.promo_code})` : ""}
                      </td>
                      <td data-label="Desconto" className="text-end text-nowrap text-muted">
                        - {formatAmount(promoOff)}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan={3} data-label="" className="text-end fw-semibold">
                      Total pago
                    </td>
                    <td data-label="Total pago" className="text-end text-nowrap fw-semibold">
                      {formatAmount(summary.amount)}
                    </td>
                  </tr>
                </tfoot>
              )}
            </Table>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}
